// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pd0[data-v-e426ee6e] {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
